<template>
  <div>
    <div class="landing-body">
      <div class="landing-wrapper">
        <AppTopbar :items="items" />

        <div class="layout-main">
          <div class="layout-content">
            <router-view />
          </div>
        </div>
        <AppFooter />
      </div>
    </div>
  </div>
</template>

<script>
import AppTopbar from "./AppTopbar.vue";
import AppFooter from "./AppFooter.vue";

export default {
  data() {
    return {
      items: Array,
    };
  },
  components: {
    AppTopbar,
    AppFooter,
  },
  created() {
    this.items = [
      { label: "Consultar", icon: "pi pi-search", to: "/decisoriosByProcesso" },
      { label: "Fale Conosco", icon: "pi pi-comments", to: "/faleConosco" },
    ];
  },
};
</script>

<style lang="scss">

</style>
